import React from "react";
import { useState, useRef, useEffect } from "react";
import ButtonSpinner from "../components/Spinner/ButtonSpinner";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { notifySuccess } from "../components/notify";
import { API_BASE_URL, BASIC_AUTH } from "../constants";
import { Image } from "react-bootstrap";
import { ToastContainer } from "react-toastify";

const SignIn = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [loginType, setLoginType] = useState("customer"); // "delivery" or "customer"
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [mobileError, setMobileError] = useState("");
  const [passError, setPassError] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const mobileRef = useRef();

  useEffect(() => {
    if (mobileRef.current) {
      mobileRef.current.focus();
    }
    if (location.state?.mobileno) {
      setMobile(location.state?.mobileno);
    }
  }, [loginType, location.state?.mobileno]);

  const validateForm = () => {
    let isValid = true;

    if (!mobile.trim()) {
      setMobileError("Mobile number is required");
      isValid = false;
    } else if (!/^\d{10}$/.test(mobile)) {
      setMobileError("Mobile number must be 10 digits");
      isValid = false;
    } else {
      setMobileError("");
    }

    if (!password.trim()) {
      setPassError("Password is required");
      isValid = false;
    } else {
      setPassError("");
    }

    return isValid;
  };

  const handleDeliverySubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMobileError("");
    setPassError("");

    // Validation first
    if (!validateForm()) return;

    setLoading(true);

    try {
      const response = await axios.get(
        `${API_BASE_URL}/delivery/delivery_agent_login`,
        {
          params: {
            MobileNo: mobile,
            Password: password,
          },
          headers: {
            Authorization: BASIC_AUTH,
          },
        },
      );

      const result = response.data;
      sessionStorage.setItem("loginuser", "true");
      localStorage.setItem("loginuser", "true");

      localStorage.setItem("loginusertype", "delivery");

      localStorage.setItem("user", JSON.stringify(response.data.user));

      localStorage.setItem("company", JSON.stringify(response.data.company));

      notifySuccess(result.RESMSG || "Login successful");
      navigate("/dashboard", { replace: true });
    } catch (err) {
      if (err.response) {
        // Server responded with error status
        const errorMessage =
          err.response?.data && typeof err.response.data === "string"
            ? err.response.data
            : err.response?.data?.message ||
              err.response?.data?.error ||
              "Login failed";

        setError(errorMessage);
      } else if (err.request) {
        // No response received
        setError("Server not responding. Please try again.");
      } else {
        // Other errors
        setError("Something went wrong.");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleCustomerSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMobileError("");
    setPassError("");

    if (!validateForm()) return;

    navigate("/company-list", {
      state: { mobile, password, flag: "fromSignin" },
      replace: true,
    });
  };

  const handleForgetPass = (e) => {
    e.preventDefault();
    if (!mobile.trim() && mobileRef) {
      setMobileError("Mobile number is required");
      mobileRef.current.focus();
      return;
    } else if (!/^\d{10}$/.test(mobile) && mobileRef) {
      setMobileError("Mobile number must be 10 digits");
      mobileRef.current.focus();
      return;
    } else {
      setMobileError("");
      navigate("/company-list", {
        state: { mobile, flag: "fromForgetPass" },
        replace: true,
      });
    }
  };

  useEffect(() => {
    const isAuthenticated = sessionStorage.getItem("loginuser");
    if (isAuthenticated) {
      navigate("/dashboard", {
        state: { flag: "show" },
        replace: true,
      });
    }
  }, [navigate]);

  const reset = () => {
    setPassword("");
    setMobile("");
    setMobileError("");
    setPassError("");
    setError("");
    setShowPassword(false);
  };

  // useEffect(() => {
  //   if (location.state?.fromSignup) {
  //     window.history.pushState(null, "", window.location.href);

  //     const handleBack = () => {
  //       navigate("/signin", { replace: true });
  //     };

  //     window.addEventListener("popstate", handleBack);

  //     return () => {
  //       window.removeEventListener("popstate", handleBack);
  //     };
  //   }
  // }, [location, navigate]);

  useEffect(() => {
    if (location.state?.fromSignup && location.state?.accountCreated) {
      notifySuccess("Account created successfully. Please login & continue.");

      // Clear state so message shows only once
      navigate(location.pathname, {
        replace: true,
        state: {},
      });
    } else if (location.state?.fromSignup) {
      window.history.pushState(null, "", window.location.href);

      const handleBack = () => {
        navigate("/signin", { replace: true });
      };

      window.addEventListener("popstate", handleBack);

      return () => {
        window.removeEventListener("popstate", handleBack);
      };
    }
  }, [location.state, navigate, location.pathname]);

  return (
    <>
      <div className="container-fluid min-vh-100 d-flex align-items-center justify-content-center bg-black">
        <div className="row w-100 justify-content-center">
          <div className="col-lg-4 col-md-6 col-sm-10">
            <div className=" shadow-sm rounded-4 bg-Modal-black">
              <div className="card-body px-2 py-3">
                <h3 className=" text-center fw-bold text-theme mb-1">NRTAIL</h3>
                {/* Header */}
                <div className="text-center mb-4">
                  <Image
                    width={75}
                    height={70}
                    src="/assest/company-logo.png"
                    alt="main_logo"
                    className="mb-2"
                  />

                  <h5 className="fw-bold text-theme mb-1">
                    {loginType === "customer"
                      ? "Customer Order"
                      : "Delivery Tracking"}
                  </h5>
                </div>
                {/* Login Type Toggle */}
                {/* <div className="login-toggle-container mb-4">
  <div className="login-toggle">
    <div
      className={`toggle-slider ${loginType === "customer" ? "right" : ""}`}
    ></div>

    <button
      type="button"
      className={loginType === "delivery" ? "active" : ""}
      onClick={() =>{
         setLoginType("delivery");
         reset() }}
    >
      Delivery Agent
    </button>

    <button
      type="button"
      className={loginType === "customer" ? "active" : ""}
      onClick={() =>{
         setLoginType("customer");
      reset() }}
    >
      Customer
    </button>
  </div>
</div> */}
                <div className="role-toggle-wrapper mb-4">
                  <div className="role-toggle">
                    {/* Sliding Background */}
                    <div
                      className={`toggle-slider ${
                        loginType === "customer" ? "slide-left" : "slide-right"
                      }`}
                    ></div>
                    <button
                      type="button"
                      className={`role-btn ${
                        loginType === "customer" ? "active-text" : ""
                      }`}
                      onClick={() => {
                        setLoginType("customer");
                        reset();
                      }}
                    >
                      <i className="fa-solid fa-user me-2"></i>
                      Customer
                    </button>
                    <button
                      type="button"
                      className={`role-btn ${
                        loginType === "delivery" ? "active-text" : ""
                      }`}
                      onClick={() => {
                        setLoginType("delivery");
                        reset();
                      }}
                    >
                      <i className="fa-solid fa-truck me-2"></i>
                      Delivery Agent
                    </button>
                  </div>
                </div>

                {/* Form */}
                <form
                  onSubmit={
                    loginType === "customer"
                      ? handleCustomerSubmit
                      : handleDeliverySubmit
                  }
                  autoComplete="off"
                  className="px-4"
                >
                  <div className="mb-3">
                    <label className="form-label small text-white fw-semibold">
                      <i className="fa-solid fa-phone text-warning"></i> Mobile
                      No. <span className="red-error">*</span>
                    </label>
                    <input
                      type="tel"
                      className="form-control"
                      placeholder="Enter mobile number"
                      ref={mobileRef}
                      value={mobile}
                      onChange={(e) =>
                        setMobile(e.target.value.replace(/\D/g, ""))
                      }
                      maxLength={10}
                    />
                    {mobileError && <p className="red-error">{mobileError}</p>}
                  </div>

                  <div className="mb-2 text-white position-relative">
                    <label className="form-label small fw-semibold">
                      <i className="fa-solid fa-lock text-warning"></i> Password{" "}
                      <span className="red-error">*</span>
                    </label>

                    <div className="position-relative">
                      <input
                        type={showPassword ? "text" : "password"}
                        className="form-control pe-5"
                        placeholder="Enter password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                      />

                      <button
                        type="button"
                        className="password_eye_container"
                        onClick={() => setShowPassword((prev) => !prev)}
                        aria-label={
                          showPassword ? "Hide Password" : "Show Password"
                        }
                      >
                        <span className="material-icons">
                          {showPassword ? "visibility_off" : "visibility"}
                        </span>
                      </button>
                    </div>

                    {passError && <p className="red-error">{passError}</p>}
                  </div>
                  {loginType === "customer" && (
                    <div className="m-0 text-end">
                      <span
                        className="text-decoration-underline text-primary font-16"
                        style={{ cursor: "pointer" }}
                        onClick={handleForgetPass}
                      >
                        Forget Password?
                      </span>
                    </div>
                  )}
                  {/* Error */}
                  {error && (
                    <div className="alert alert-danger py-2 small text-center">
                      {error}
                    </div>
                  )}

                  {/* Submit */}
                  <div className="d-flex justify-content-center align-items-center mb-1 mt-4">
                    <ButtonSpinner
                      type="submit"
                      className="col-9 btn-theme  bg-gradient-info btn-md text-black"
                      loading={loading}
                    >
                      <b>{loading ? "Signing in..." : "Sign In"}</b>
                    </ButtonSpinner>
                  </div>
                  {loginType === "customer" && (
                    <div className="m-0 text-center">
                      <span
                        className="text-decoration-underline text-theme font-16"
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          navigate("/company-list", { replace: true })
                        }
                      >
                        Sign Up.
                      </span>
                    </div>
                  )}
                </form>

                {/* Footer */}
                <div className="text-center mt-4">
                  <small className="text-white">
                    © 2026 NPRO Software Solutions Pvt Ltd
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </>
  );
};

export default SignIn;
